import { Spinner2 } from 'components';
import { fmtDate } from '../constants';
import { LevelBadge } from './ui';

const COLS = ['Term', 'Level', 'Status', 'Added by', 'Updated', 'Actions'];

const actionBtnCls =
  'text-[12px] font-medium px-2 py-1 rounded-md border transition-colors disabled:opacity-50 disabled:cursor-default';

const TermsTable = ({ rows, loading, busyId, onEdit, onToggleActive, onDelete }) => {
  if (loading) {
    return (
      <div className="flex justify-center py-16">
        <Spinner2 />
      </div>
    );
  }

  if (!rows.length) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <div className="w-12 h-12 rounded-xl bg-[#F0F2F4] flex items-center justify-center mb-4">
          <svg className="w-5 h-5 text-[#B5BDCA]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M21 21l-4.35-4.35M17 11a6 6 0 11-12 0 6 6 0 0112 0z" />
          </svg>
        </div>
        <p className="text-[13px] text-[#97A3B5]">No terms match these filters</p>
      </div>
    );
  }

  return (
    <div className="rounded-xl border border-[#D2D8DF] overflow-x-auto">
      <table className="w-full text-left border-collapse min-w-[760px]">
        <thead>
          <tr className="bg-[#F0F2F4] border-b border-[#D2D8DF]">
            {COLS.map((col) => (
              <th
                key={col}
                className="px-3 py-2.5 text-[10px] font-semibold text-[#7989A0] uppercase tracking-wide whitespace-nowrap"
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((term, i) => {
            const busy = busyId === term._id;
            return (
              <tr
                key={term._id}
                className={`border-b border-[#F0F2F4] last:border-0 hover:bg-[#F8FAFC] transition-colors ${
                  i % 2 === 1 ? 'bg-[#FAFAFA]' : 'bg-white'
                }`}
              >
                <td className="px-3 py-2.5">
                  <span
                    className={`text-[12.5px] font-mono break-all ${
                      term.active ? 'text-[#353E4A]' : 'text-[#97A3B5] line-through'
                    }`}
                  >
                    {term.term}
                  </span>
                </td>
                <td className="px-3 py-2.5 whitespace-nowrap">
                  <LevelBadge level={term.level} />
                </td>
                <td className="px-3 py-2.5 whitespace-nowrap">
                  <span
                    className={`text-[11px] font-semibold rounded-full px-2 py-0.5 ${
                      term.active
                        ? 'text-[#0C9C74] bg-[#E7FBF3] border border-[#B8F0DC]'
                        : 'text-[#64748B] bg-[#F1F5F9] border border-[#E2E8F0]'
                    }`}
                  >
                    {term.active ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td className="px-3 py-2.5 text-[12px] text-[#5F6F86] whitespace-nowrap">
                  {term.addedBy?.username
                    ? `@${term.addedBy.username}`
                    : term.addedBy?.name || term.addedBy?.email || 'seed'}
                </td>
                <td className="px-3 py-2.5 text-[11px] text-[#5F6F86] whitespace-nowrap">
                  {fmtDate(term.updatedAt)}
                </td>
                <td className="px-3 py-2.5 whitespace-nowrap">
                  <div className="flex items-center gap-1.5">
                    <button
                      type="button"
                      disabled={busy}
                      onClick={() => onEdit(term)}
                      className={`${actionBtnCls} border-[#D2D8DF] text-[#5F6F86] hover:bg-[#F0F2F4]`}
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      disabled={busy}
                      onClick={() => onToggleActive(term)}
                      className={`${actionBtnCls} border-[#D2D8DF] text-[#5F6F86] hover:bg-[#F0F2F4]`}
                    >
                      {term.active ? 'Deactivate' : 'Activate'}
                    </button>
                    <button
                      type="button"
                      disabled={busy}
                      onClick={() => onDelete(term)}
                      className={`${actionBtnCls} border-[#FECDD3] text-[#E11D48] hover:bg-[#FFF1F2]`}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TermsTable;
